import React, { useState } from 'react';
import { useTranslation } from '../i18n';

export default function BugModal({ isOpen, onClose, lastApiPayload, onSendMessage }) {
  const { t } = useTranslation();
  const [status, setStatus] = useState('idle');
  const [category, setCategory] = useState('');
  const [description, setDescription] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    
    try {
      const bugMessage = `BUG REPORT:\nCategory: ${category}\nDescription: ${description}\n\nAPI Payload:\n${JSON.stringify(lastApiPayload, null, 2)}`;
      
      await onSendMessage(bugMessage);
      setStatus('success');
      
      setTimeout(() => {
        handleClose();
      }, 1500);
    } catch {
      setStatus('error');
    }
  };

  const handleClose = () => {
    setStatus('idle');
    setCategory('');
    setDescription('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="contact-modal" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="modal-close" onClick={handleClose}>
          <span className="material-symbols-outlined">close</span>
        </button>
        <h2>{t('bug.title')}</h2>
        {status === 'success' ? (
          <p className="modal-success">{t('bug.success')}</p>
        ) : (
          <form onSubmit={handleSubmit}>
            <select 
              name="category" 
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              required
            >
              <option value="">{t('bug.selectCategory')}</option>
              <option value="ui">{t('bug.categoryUI')}</option>
              <option value="functionality">{t('bug.categoryFunctionality')}</option>
              <option value="performance">{t('bug.categoryPerformance')}</option>
              <option value="content">{t('bug.categoryContent')}</option>
              <option value="other">{t('bug.categoryOther')}</option>
            </select>
            <textarea 
              name="description" 
              placeholder={t('bug.descriptionPlaceholder')} 
              required 
              rows={5}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
            {lastApiPayload && (
              <div className="bug-payload-section">
                <label>{t('bug.payloadLabel')}</label>
                <textarea 
                  readOnly
                  className="bug-payload-textarea"
                  value={JSON.stringify(lastApiPayload, null, 2)}
                  rows={10}
                />
              </div>
            )}
            <button type="submit" disabled={status === 'sending'}>
              {status === 'sending' ? t('bug.sending') : t('bug.submit')}
            </button>
          </form>
        )}
        {status === 'error' && <p className="modal-error">{t('bug.error')}</p>}
      </div>
    </div>
  );
}